export default __webpack_public_path__ + "static/media/feedback.11787581.svg";